import React, { forwardRef } from 'react'
import { InputProps } from '.'
import { ReactComponent as CheckIcon } from '@icons/check2.svg'
import styled from 'styled-components'
import { colors } from '@styles/vars'

interface RadioProps extends InputProps {
    label: string | React.ReactNode
}

const Radio = ({ label, background, ...attributes }: RadioProps, ref: any) => {
    return (
        <Wrapper background={background}>
            <input {...attributes} ref={ref} />
            <label htmlFor={attributes.id}>
                <div className="icon"><CheckIcon /></div>
                {label}
            </label>
        </Wrapper>
    )
}

export default forwardRef(Radio)

/* STYLES */
const Wrapper = styled.div<{ background?: string }>`
    input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }

    input:checked + label {
        .icon {
            background: ${colors.black};
        }

        svg {
            display: block;
            fill: ${colors.white};
        }
    }

    label {
        display: flex;
        cursor: pointer;
        line-height: 150%;

        .icon {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: ${props => props.background || colors.white};
            border: 1px solid ${colors.border};
            margin-right: 10px;
            transition: .2s ease-out;
            flex-shrink: 0;
            margin-top: -2px;
        }

        svg {
            display: none;
        }
    }
`
